<template>
  <div>
    <el-tooltip v-if="tip" effect="light" :content="value" placement="top">
      <span>{{ showVal }}</span>
    </el-tooltip>
    <span v-else>{{ showVal }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String],
      default: () => {
        return "";
      },
    },
    tip: {
      type: [Boolean],
      default: () => {
        return false;
      },
    },
  },
  computed: {
    showVal() {
      let res = "";
      if (this.value) {
        if (this.value.length > 10) {
          res =
            this.value.substring(0, 5) +
            "..." +
            this.value.substring(this.value.length - 4);
        } else {
          res = this.value;
        }
      }
      return res;
    },
  },
  methods: {},
  watch: {},
};
</script>
<style scoped lang="scss"></style>
